import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba89d556"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-acc-title" }, "Retina access", -1 /* HOISTED */))
const _hoisted_2 = ["title", "aria-pressed"]
const _hoisted_3 = {
  key: 0,
  class: "nge-acc-how"
}
const _hoisted_4 = {
  key: 0,
  class: "nge-acc-slimline"
}
const _hoisted_5 = {
  key: 1,
  class: "nge-acc-slimline nge-acc-slimline--redo"
}
const _hoisted_6 = {
  key: 2,
  class: "nge-acc-slimline nge-acc-slimline--yes"
}
const _hoisted_7 = {
  key: 3,
  class: "nge-acc-how nge-acc-steps"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Find ten mistakes on cells that are not tutorial cells, in the Sandbox or the retina.", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Seven cuts:"),
  /*#__PURE__*/_createTextVNode(" place red and blue Multicut (cut) points on each side of where you would cut.")
], -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Three merges:"),
  /*#__PURE__*/_createTextVNode(" press M, then Ctrl+click the two pieces to place merge points.")
], -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Place the cut or merge points, but do not submit the edit."),
  /*#__PURE__*/_createTextVNode(" Then save the view here.")
], -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 4,
  class: "nge-acc-state"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 5,
  class: "nge-acc-state nge-acc-state--redo"
}
const _hoisted_16 = {
  key: 0,
  class: "nge-acc-quote"
}
const _hoisted_17 = {
  key: 6,
  class: "nge-acc-state nge-acc-state--yes"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Congratulations! Your edit access has been granted!", -1 /* HOISTED */))
const _hoisted_19 = {
  key: 0,
  class: "nge-acc-quote"
}
const _hoisted_20 = {
  key: 7,
  class: "nge-acc-live"
}
const _hoisted_21 = { class: "nge-acc-sec" }
const _hoisted_22 = { class: "nge-acc-count" }
const _hoisted_23 = {
  key: 0,
  class: "nge-acc-sub"
}
const _hoisted_24 = { class: "nge-acc-list" }
const _hoisted_25 = { class: "nge-acc-row" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "nge-acc-n" }
const _hoisted_28 = {
  key: 0,
  class: "nge-acc-verdict"
}
const _hoisted_29 = ["aria-expanded", "onClick"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = ["disabled", "aria-label", "onClick"]
const _hoisted_32 = {
  key: 0,
  class: "nge-acc-note"
}
const _hoisted_33 = {
  key: 1,
  class: "nge-acc-marks"
}
const _hoisted_34 = {
  key: 0,
  class: "nge-acc-quote"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-acc-dot" }, null, -1 /* HOISTED */))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = ["disabled", "onClick"]
const _hoisted_39 = {
  key: 1,
  class: "nge-acc-confirm",
  role: "alertdialog",
  "aria-label": "Confirm the save"
}
const _hoisted_40 = { class: "nge-acc-confirm-btns" }
const _hoisted_41 = {
  key: 0,
  class: "nge-acc-label"
}
const _hoisted_42 = {
  key: 1,
  class: "nge-acc-label"
}
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 10,
  class: "nge-acc-admin"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 11,
  class: "nge-acc-help"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://connectome.quest/blog/how-to-unlock-edit-access-in-pyr/",
  target: "_blank",
  rel: "noopener"
}, "How access works ↗", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "boxEl",
    class: _normalizeClass(["nge-acc", { 'nge-acc--dragging': $setup.dragging, 'nge-acc--slim': $setup.slim }]),
    style: _normalizeStyle($setup.posStyle),
    role: "dialog",
    "aria-label": "Ask for Edit Access"
  }, [
    _createElementVNode("div", {
      class: "nge-acc-head",
      title: "Drag to move",
      onPointerdown: _cache[1] || (_cache[1] = (...args) => ($setup.startDrag && $setup.startDrag(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("button", {
        class: "nge-acc-size",
        title: $setup.slim ? 'Show everything' : 'Make the box smaller',
        "aria-pressed": $setup.slim,
        onClick: $setup.toggleSlim
      }, _toDisplayString($setup.slim ? 'Full' : 'Slim'), 9 /* TEXT, PROPS */, _hoisted_2),
      _createElementVNode("button", {
        class: "nge-acc-close",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
      }, "×")
    ], 32 /* HYDRATE_EVENTS */),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading your request…"))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($setup.slim && $setup.status === 'submitted')
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Sent. Waiting for a review."))
            : ($setup.slim && $setup.status === 'redo')
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.redoLeft === 1 ? '1 example' : `${$setup.redoLeft} examples`) + " to redo. Full shows the notes.", 1 /* TEXT */))
              : ($setup.slim && $setup.status === 'invited')
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Your edit access has been granted!"))
                : ($setup.status === 'draft' && !$setup.slim)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_7, _hoisted_12))
                  : ($setup.status === 'submitted' && !$setup.slim)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createTextVNode(" Sent" + _toDisplayString($setup.request?.submitted_at ? ` on ${$setup.when($setup.request.submitted_at)}` : '') + ". A reviewer is looking at your examples. You will hear back in your notifications. ", 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "nge-acc-back",
                          disabled: !!$setup.busy,
                          onClick: $setup.takeBack
                        }, _toDisplayString($setup.busy === 'back' ? 'Taking back…' : 'Take them back to change'), 9 /* TEXT, PROPS */, _hoisted_14)
                      ]))
                    : ($setup.status === 'redo' && !$setup.slim)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("b", null, "A reviewer would like " + _toDisplayString($setup.redoLeft === 1 ? 'one example' : `${$setup.redoLeft} examples`) + " again.", 1 /* TEXT */),
                          _createTextVNode(" Their notes are on each one below. Redo those (you can change any of the others too), then send again. "),
                          ($setup.request?.reviewer_note)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($setup.request.reviewer_note), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : ($setup.status === 'invited' && !$setup.slim)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode(" The retina is open to you for editing. If it still says View only, sign out of Pyr and back in. "),
                            ($setup.request?.reviewer_note)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($setup.request.reviewer_note), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
          ($setup.canEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.liveLine), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.KINDS, (kind) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: kind }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", null, _toDisplayString(kind === 'cut' ? 'Cuts' : 'Merges'), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_22, _toDisplayString($setup.countOf(kind)) + " of " + _toDisplayString($setup.ACCESS_SLOTS[kind]), 1 /* TEXT */)
              ]),
              (!$setup.slim)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(kind === 'cut' ? 'Two cells wrongly joined: Multicut points, not cut' : 'One cell wrongly broken in two: merge points, not merged'), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("ul", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($setup.slim ? [] : $setup.filled(kind)), (row) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: kind + row.s,
                    class: _normalizeClass(["nge-acc-item", { 'nge-acc-item--good': row.it.verdict === 'good', 'nge-acc-item--redo': row.it.verdict === 'redo' }])
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        class: "nge-acc-open",
                        title: "Go back to this view",
                        onClick: $event => ($setup.open(row.it))
                      }, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(row.s), 1 /* TEXT */),
                        _createTextVNode(_toDisplayString($setup.summary(row.it)), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_26),
                      (row.it.verdict)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(row.it.verdict === 'good' ? 'good' : 'redo'), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($setup.hasMarks(row.it))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "nge-acc-more",
                            "aria-expanded": $setup.openKey === kind + row.s,
                            onClick: $event => ($setup.openKey = $setup.openKey === kind + row.s ? '' : kind + row.s)
                          }, _toDisplayString($setup.openKey === kind + row.s ? 'Hide notes' : 'Notes'), 9 /* TEXT, PROPS */, _hoisted_29))
                        : _createCommentVNode("v-if", true),
                      ($setup.canEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "nge-acc-rep",
                            disabled: !!$setup.busy,
                            title: "Put the view you are looking at in this slot",
                            onClick: $event => ($setup.askSave(kind, row.s))
                          }, _toDisplayString($setup.busy === kind + row.s ? 'Saving…' : 'Replace'), 9 /* TEXT, PROPS */, _hoisted_30))
                        : _createCommentVNode("v-if", true),
                      ($setup.canEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            class: "nge-acc-x",
                            disabled: !!$setup.busy,
                            "aria-label": `Remove ${kind} ${row.s}`,
                            onClick: $event => ($setup.remove(kind, row.s))
                          }, "×", 8 /* PROPS */, _hoisted_31))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (row.it.note)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Your note: " + _toDisplayString(row.it.note), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.openKey === kind + row.s)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          (row.it.feedback)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(row.it.feedback), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pointList(row.it), (p) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: p.key,
                              class: _normalizeClass(["nge-acc-pt", `nge-acc-pt--${p.color}`]),
                              title: "Fly to this point",
                              onClick: $event => ($setup.flyToPoint(p.position))
                            }, [
                              _hoisted_36,
                              _createTextVNode(_toDisplayString(p.n), 1 /* TEXT */),
                              (p.mark)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["nge-acc-ptmark", `nge-acc-ptmark--${p.mark}`])
                                  }, _toDisplayString(p.mark), 3 /* TEXT, CLASS */))
                                : _createCommentVNode("v-if", true)
                            ], 10 /* CLASS, PROPS */, _hoisted_35))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */)),
                ($setup.canEdit && $setup.nextSlot(kind) !== null)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                      _createElementVNode("button", {
                        class: "nge-acc-save",
                        disabled: !!$setup.busy,
                        onClick: $event => ($setup.saveNext(kind))
                      }, _toDisplayString($setup.saveLabel(kind)), 9 /* TEXT, PROPS */, _hoisted_38)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" The yes, right under the button that asked for it. "),
                ($setup.confirming && $setup.confirming.kind === kind)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                      _createElementVNode("p", null, _toDisplayString($setup.confirming.text), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("button", {
                          class: "nge-acc-confirm-yes",
                          onClick: $setup.confirmYes
                        }, _toDisplayString($setup.confirming.yes), 1 /* TEXT */),
                        _createElementVNode("button", {
                          class: "nge-acc-confirm-no",
                          onClick: _cache[2] || (_cache[2] = $event => ($setup.confirming = null))
                        }, "Cancel")
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 64 /* STABLE_FRAGMENT */))
          }), 64 /* STABLE_FRAGMENT */)),
          ($setup.canEdit)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                (!$setup.slim)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_41, [
                      _createTextVNode("Note for the reviewer, " + _toDisplayString($setup.noteGoes) + " (optional) ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.note) = $event)),
                        class: "nge-acc-input",
                        rows: "2",
                        maxlength: "1000",
                        placeholder: "Where the merger starts, what you checked"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.note]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (!$setup.slim)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_42, [
                      _createTextVNode("Your EyeWire username (optional) "),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.ewName) = $event)),
                        class: "nge-acc-input",
                        maxlength: "60"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.ewName]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  class: "nge-acc-send",
                  disabled: $setup.busy === 'send',
                  onClick: $setup.send
                }, _toDisplayString($setup.busy === 'send' ? 'Sending…' : `Send for review (${$setup.total} of 10)`), 9 /* TEXT, PROPS */, _hoisted_43)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          ($setup.message)
            ? (_openBlock(), _createElementBlock("p", {
                key: 9,
                class: _normalizeClass(["nge-acc-msg", { 'nge-acc-msg--bad': $setup.messageBad }]),
                role: "status"
              }, _toDisplayString($setup.message), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true),
          ($setup.backend.showAdminUi && $setup.request && !$setup.slim)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "nge-acc-rep",
                  disabled: !!$setup.busy,
                  onClick: _cache[5] || (_cache[5] = $event => ($setup.askingReset = true))
                }, "Start over (admins, for testing)", 8 /* PROPS */, _hoisted_45),
                ($setup.askingReset)
                  ? (_openBlock(), _createBlock($setup["ConfirmDialog"], {
                      key: 0,
                      title: "Start over?",
                      text: "This deletes your request, its ten examples and every mark and note on them, for good. It cannot be undone.",
                      yes: "Delete for good",
                      onYes: $setup.startOver,
                      onNo: _cache[6] || (_cache[6] = $event => ($setup.askingReset = false))
                    }))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (!$setup.slim)
            ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                _createTextVNode(" Taking more than one try is normal. You are never locked out. "),
                _hoisted_47
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ], 6 /* CLASS, STYLE */))
}